import React from 'react';
import ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import Home from './Home';
import ZzbHome from './ZzbHome';
import ZzbReceive from './ZzbReceive';
import ZzbExchange from './ZzbExchange';
import Rules from './Rules';
import Receive from './Receive';
import * as activityPunchService from '../../../service/activity-punch';
import * as zzbService from '../../../service/zzb';
import { isLogin, gotoLogin, handleLogin } from '../../../util-lib/login/login-controller';
import * as Toast from '../../Toast';
import {
  hideWebActivity
} from '../../../util-lib/native';
import { onPageShow, offPageShow } from '../../../native';
import { ApiError } from '../../../util-lib/http';
import { REG_PHONE } from '../../../util-lib/regex';
import * as localStorageManager from '../../../util-lib/local-storage';
import { createApiContainer } from '../../ApiContainer';
import { sa } from '../../../util-lib/statistics';
import './style.scss';

export const START_COUNTDOWN_MESSAGE_KEY = 'PUNCH_MESSAGE/startCountdown';
export const UPDATE_STATUS_MESSAGE_KEY = 'PUNCH_MESSAGE/updateStatus';

// views
// home 打卡首页
// rules 打卡规则
// receive 领奖状态
// receive 领奖成功
// receive 打卡完成
class PunchModal extends React.Component {
  static propTypes = {
    query: PropTypes.shape({}),
    onClose: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.state = {
      status: 0,
      isRestart: false,
      view: null,
      awards: [],
      day: 0,
      receivingAward: null,
      exchangingGoods: null,
      receivingZzbValue: 0,
      phone: '',
      inputError: null,
      isLogin: isLogin(),
      isSendingReceiveRequest: false,
      isSendingExchangingRequest: false,
      readOnly: true
      // startDate: '',
      // endDate: ''
    };

    this.query = props.query;
  }


  componentDidMount() {
    this.initialize();
  }

  componentWillUnmount() {
    offPageShow(this.handlePageShow);
  }

  initialize = () => {
    const { view } = this.query;
    if (
      view === 'rules'
      || view === 'zzb-rules'
      || view === 'zzb-rules-only'
    ) {
      this.setState({
        view
      });
      return;
    }

    if (view === 'zzb-receive') {
      const { receivingZzbValue } = this.query;
      this.setState({
        view,
        receivingZzbValue: Number(receivingZzbValue)
      });
      return;
    }

    this.initActivityPunchInfo();
    this.bindPageShow();
  }

  initActivityPunchInfo = () => {
    activityPunchService.getInfo().then((data) => {
      let { view = 'home' } = this.query;
      const { day } = this.query;
      const {
        dailyList, dailyOffset, phone, startDate, endDate, joinStatus, restart,
        dailyVersion
      } = data;
      const awards = dailyList;
      if (view === 'home' && dailyVersion === 2) {
        view = 'zzb-home';
      }
      const state = {
        status: joinStatus, // 0 打卡进行中 1 等待领奖 2 已完成
        isRestart: restart === 1,
        view,
        awards,
        day: dailyOffset,
        phone,
        readOnly: !!phone,
        startDate,
        endDate
      };
      if (view === 'receive') {
        const intDay = parseInt(day, 10);
        const receivingAward = awards.find(_ => _.offset === intDay);

        if (receivingAward) {
          state.receivingAward = receivingAward;
          state.day = intDay;
        }
      }
      if (view === 'zzb-exchange') {
        const { exchangingGoods } = this.query;
        state.exchangingGoods = exchangingGoods;
      }
      this.setState(state);
    }).catch((error) => {
      Toast.show({
        content: ApiError.getOneError(error.message)
      });
      setTimeout(hideWebActivity, 1000);
    });
  }

  bindSetView = view => () => {
    this.setView(view);

    if (view === 'rules') {
      sa.track('click', {
        obj_type: 'punch',
        obj_id: 'rules'
      });
    }
  }

  bindPageShow = () => {
    onPageShow(this.handlePageShow);
    handleLogin(() => {
      this.setState({
        isLogin
      });
    });
  }

  handlePageShow = () => {
    const { view } = this.state;
    if (
      view === 'home'
      || view === 'zzb-home'
      || view === null
    ) {
      this.initActivityPunchInfo();
    }
  }

  setView = (view) => {
    this.setState({
      view
    });
  }

  setReceivingAward = (receivingAward) => {
    this.setState({
      receivingAward
    });
  }

  handleAwardItemClick = (award) => {
    const { status } = award;
    // 只有「立即领取」状态可点击
    if (status !== 1) {
      return;
    }

    this.setView('receive');
    this.setReceivingAward(award);

    // if (prizeType === 1) { // 站内发放，不需要填手机
    //   this.handleReceiveAwardType1(award);
    // } else {
    //   this.setView('receive');
    //   this.setReceivingAward(award);
    // }
  }

  handleZzbItemClick = (award) => {
    let url = '/tantu/webapp/punch/landing';
    const { status, offset } = award;
    // 只有「立即领取」状态可点击
    if (status === 1) {
      url += `?getZzbOffset=${offset}`;
    }

    window.location.href = url;
  }

  handleInputChange = (e) => {
    this.setState({
      phone: e.target.value,
      inputError: null
    });
  }

  /**
   * 领取站内奖品
   */
  handleReceiveAwardType1 = () => {
    const { isLogin, receivingAward } = this.state;
    const dailyOffset = receivingAward.offset;
    if (!isLogin) {
      gotoLogin();
      return;
    }

    this.setState({
      isSendingReceiveRequest: true
    });
    activityPunchService.setInfo({
      action: '2',
      dailyOffset
    }).then(() => {
      this.handleReceiveSuccess(dailyOffset);
    }).catch(this.handleReceiveFail);
  }

  handleReceiveAwardType2 = () => {
    const { phone, receivingAward } = this.state;
    const dailyOffset = receivingAward.offset;
    this.setState({
      isSendingReceiveRequest: true
    });
    activityPunchService.setInfo({
      action: '2',
      dailyOffset,
      phone
    }).then(() => {
      this.handleReceiveSuccess(dailyOffset);
    }).catch(this.handleReceiveFail);
  }

  handleReceiveSuccess = () => {
    localStorageManager.setItem(UPDATE_STATUS_MESSAGE_KEY, '1');

    Toast.show({
      content: '领取成功！'
    });

    // 直接关闭
    setTimeout(() => {
      this.handleClose();
      this.setState({
        view: 'home'
      });
    }, 1200);
  }

  handleReceiveFail = (error) => {
    const { message, code } = error;
    this.setState({
      isSendingReceiveRequest: false
    });

    Toast.show({
      content: ApiError.getOneError(message),
      onShowEnd: () => {
        // 重复领取
        // 直接关闭弹窗
        if (code === 7002) {
          setTimeout(() => {
            this.handleClose();
            this.setState({
              view: 'home'
            });
          }, 1000);
        }
      }
    });
  }

  handleGoToMall = () => {
    const { day } = this.state;

    // 旅行商城首页打开的话就不需要再跳了
    if (this.query.context !== 'poi') {
      // backToHome('mall');
      window.location.href = '/tantu/webapp/innovation/discount-headline-list';
    } else {
      this.handleClose();
    }

    sa.track('click', {
      obj_type: 'punch',
      obj_id: 'go',
      day
    });
  }

  handleStartCountdown = () => {
    const { awards, day } = this.state;

    // 需要倒计时才发信号
    if (!this.query.view || this.query.view === 'home') {
      const todayAward = awards.find(_ => _.offset === day);
      if (todayAward && todayAward.status === 0) {
        // 如果倒计时 就不需要重新更新状态先
        localStorageManager.removeItem(UPDATE_STATUS_MESSAGE_KEY);
        localStorageManager.setItem(START_COUNTDOWN_MESSAGE_KEY, '1');
        // localStorageManager.postMessage(START_COUNTDOWN_MESSAGE_KEY, 1);

        activityPunchService.setInfo({
          action: '7',
          dailyOffset: day
        }).then(console.log).catch(console.log);
      }
    }

    this.handleGoToMall();
  }

  handleClose = () => {
    // if (this.query.view === 'receive') {
    //   localStorageManager.setItem(UPDATE_STATUS_MESSAGE_KEY, '1');
    //   // localStorageManager.postMessage(UPDATE_STATUS_MESSAGE_KEY, 1);
    // }
    const { onClose } = this.props;
    if (onClose && onClose.call) {
      onClose();
    } else {
      hideWebActivity();
    }
  }

  handleEdit = () => {
    this.setState({
      readOnly: false
    }, () => {
      const $input = document.querySelector('.J-punch-phone-input');
      $input.focus();
    });
  }

  handleSubmit = () => {
    const { phone, receivingAward } = this.state;
    if (receivingAward.prizeType === 1) {
      this.handleReceiveAwardType1();
      return;
    }
    if (!phone || !REG_PHONE.test(phone)) {
      this.setState({
        inputError: '请输入正确的手机号！'
      });
      return;
    }

    this.setState({
      inputError: null
    });

    this.handleReceiveAwardType2();
  }

  handleExchange = () => {
    if (!isLogin) {
      gotoLogin();
      return;
    }

    const { phone, exchangingGoods } = this.state;
    const { id, awardType } = exchangingGoods;

    if (awardType === 2) {
      if (!phone || !REG_PHONE.test(phone)) {
        this.setState({
          inputError: '请输入正确的手机号！'
        });
        return;
      }
    }

    this.setState({
      isSendingExchangingRequest: true,
      inputError: null
    });

    zzbService.exchangeGoods({
      id,
      phone
    }).then((res) => {
      const { status } = res;
      this.setState({
        isSendingExchangingRequest: false
      });

      if (!status) {
        Toast.show({
          content: '系统开小差了，兑换失败，请重试~'
        });
        return;
      }

      Toast.show({
        content: '兑换成功！'
      });

      // 直接关闭
      setTimeout(this.handleClose, 1200);
    }).catch((error) => {
      this.setState({
        isSendingExchangingRequest: false
      });

      const { message } = error;

      Toast.show({
        content: ApiError.getOneError(message)
      });
    });
  }

  renderView = (view) => {
    if (view === null) return null;
    const {
      awards, day, receivingAward, isLogin, phone, readOnly, inputError,
      isSendingReceiveRequest, status, isRestart, receivingZzbValue, exchangingGoods,
      isSendingExchangingRequest
    } = this.state;
    switch (view) {
      case 'zzb-home':
        return (
          <ZzbHome
            day={day}
            awards={awards}
            onRuleButtonClick={this.bindSetView('zzb-rules')}
            onAwardItemClick={this.handleZzbItemClick}
            onClose={this.handleClose}
            onGoToMall={this.handleGoToMall}
            onStartCountdown={this.handleStartCountdown}
          />
        );
      case 'zzb-receive':
        return (
          <ZzbReceive
            value={receivingZzbValue}
            onConfirm={this.handleClose}
          />
        );
      case 'zzb-rules':
        return <Rules ruleName="zzb" onConfirm={this.bindSetView('zzb-home')} />;
      case 'zzb-rules-only':
        return <Rules ruleName="zzb" onConfirm={this.handleClose} />;
      case 'zzb-exchange':
        return (
          <ZzbExchange
            exchangingGoods={exchangingGoods}
            isLogin={isLogin}
            isReceiving={isSendingExchangingRequest}
            phone={phone}
            error={inputError}
            readOnly={readOnly}
            onInputChange={this.handleInputChange}
            onEdit={this.handleEdit}
            onSubmit={this.handleExchange}
            onClose={this.handleClose}
          />
        );
      case 'home':
        return (
          <Home
            status={status}
            isRestart={isRestart}
            day={day}
            awards={awards}
            onRuleButtonClick={this.bindSetView('rules')}
            onAwardItemClick={this.handleAwardItemClick}
            onClose={this.handleClose}
            onGoToMall={this.handleGoToMall}
            onStartCountdown={this.handleStartCountdown}
          />
        );
      case 'rules':
        return <Rules onConfirm={this.bindSetView('home')} />;
      case 'receive':
        return (
          <Receive
            type="receive"
            receivingAward={receivingAward}
            isLogin={isLogin}
            isReceiving={isSendingReceiveRequest}
            phone={phone}
            error={inputError}
            readOnly={readOnly}
            onInputChange={this.handleInputChange}
            onEdit={this.handleEdit}
            onSubmit={this.handleSubmit}
            onClose={this.handleClose}
          />
        );
      case 'finish':
        return (
          <Receive type="finish" onClose={this.handleClose} />
        );
      default:
        return null;
    }
  }

  render() {
    const { view } = this.state;

    // if (view === null) return null;

    return (
      <article className="ap-container">
        {/* <section className="ap-bg" /> */}
        <section className="ap-wrapper">
          <section className="ap-main">
            <section className="ap-body">
              {this.renderView(view)}
            </section>
          </section>
        </section>
      </article>
    );
  }
}

let $container = null;

export const showPunchModal = (options = {}) => {
  if (!$container) {
    $container = createApiContainer();
  }

  ReactDOM.render(
    <PunchModal
      key={Date.now()}
      query={options.query || {}}
      onClose={options.onClose}
    />,
    $container
  );
};

export const hidePunchModal = () => {
  if (!$container) return;
  ReactDOM.unmountComponentAtNode($container);
};

export default PunchModal;
